import { useAccount } from 'reservations/account/providers/AccountProvider';

const useBrandImage = (): { imgURL: string; altText: string } => {
  const { brandImage } = useAccount();
  const { image_large_url, url = '', alt_text = '' } = brandImage;

  return {
    imgURL: image_large_url ?? url,
    altText: alt_text
  };
};

export default useBrandImage;
